module.exports = __webpack_public_path__ + "img/vertical_7_7_9006.1645fa83.png";